import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AbstractWebSocketService, WebSocketRequestOptions, WebSocketServiceConfig } from 'types';
import { HWServiceConfig } from './hw-service-config';

export class TransportDbMessage {
  uid: string;
  type: number;
}

export class TransportListMessagesFilter {
  type?: number;
  types?: number[];
  sender?: string;
  receiver?: string;
  package_key?: string;
  action_exists?: {
    who?: number;
    what?: number;
  };
  action_not_exists?: {
    who?: number;
    what?: number;
  };
}

class xmlNamespaces {
  constructor(readonly a: string, readonly b: string) {}
}

@Injectable()
export class TransportService extends AbstractWebSocketService {
  private readonly namespaces: xmlNamespaces = new xmlNamespaces('http://inforser.ru/pvdnp/v1', 'http://inforser.ru/PVDNP/2');

  constructor(config: HWServiceConfig) {
    super(new WebSocketServiceConfig(config.getHWServiceUrl(), config.getTransportServiceProtocol()));
  }

  beginTransaction(): Observable<void> {
    let request = { command: 'begin-tdb-tx', filename: 'fptransport.db', progress: false };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((r) => undefined));
  }

  commitTransaction(): Observable<void> {
    let request = { command: 'commit-tdb-tx', progress: false };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((r) => undefined));
  }

  rollbackTransaction(): Observable<void> {
    let request = { command: 'rollback-tdb-tx', progress: false };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((r) => undefined));
  }

  list(filter?: TransportListMessagesFilter): Observable<TransportDbMessage[]> {
    let request = {
      command: 'list',
      progress: false,
      filter: {
        'type': filter?.type,
        'types': filter?.types,
        'sender': filter?.sender,
        'receiver': filter?.receiver,
        'package-key': filter?.package_key,
        'action-exists': {
          who: filter?.action_exists?.who,
          what: filter?.action_exists?.what,
        },
        'action-not-exists': {
          who: filter?.action_not_exists?.who,
          what: filter?.action_not_exists?.what,
        },
      },
    };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(
      map((response: any) => {
        const result: TransportDbMessage[] = response.messages.map((message: any) => {
          const tm = new TransportDbMessage();
          tm.uid = message.uid;
          tm.type = message.type;
          return tm;
        });
        return result;
      }),
    );
  }

  parse(uid: string, expressions: string[], method = 'xpath'): Observable<string[][]> {
    let request = {
      command: 'parse-message',
      uid,
      method,
      expressions,
      namespaces: this.namespaces,
    };

    // в поле data всегда возвращается [<array of strings>, ... ]
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((response: any) => response.data));
  }

  getMessageData(uid: string): Observable<string> {
    let request = { command: 'get-message-data', uid };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((response: any) => response.data));
  }

  createMessage(
    uid: string,
    type: number,
    sender: string,
    receiver: string,
    format: string,
    packageKey: string,
    data: string,
  ): Observable<void> {
    let request = {
      command: 'create-message',
      uid: uid,
      type: type,
      sender: sender,
      receiver: receiver,
      format: format,
      package_key: packageKey,
      data: data,
    };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((r) => undefined));
  }

  removeMessage(uid: string): Observable<void> {
    let request = { command: 'remove-message', uid: uid };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((r) => undefined));
  }

  addMessageAction(uid: string, what: number): Observable<void> {
    let request = { command: 'add-message-action', uid: uid, what: what };
    return this.sendRequest(request, new WebSocketRequestOptions()).pipe(map((r) => undefined));
  }
}
